import Vue from "vue";
import Dropdown from "@/components/dropdown/dropdown.vue";

Vue.component("m-dropdown", Dropdown);
